import { jsx as o } from "react/jsx-runtime";
import { READMORE_CHAR_CUTOFF as p } from "../../constants/index.js";
import "react";
import { classes as s } from "../../utils/styles.js";
import { ReadMore as a } from "../ReadMore/index.js";
import { useTranslation as d } from "../../hooks/useTranslation.js";
import "../Context/index.js";
import "../IconButton/index.js";
import "../../pagination-BeOG0tbT.js";
import "../ProductTable/TableRowGroup.js";
import "../../types/apiSchema.js";
import "../../types/localizationSchema.js";
import e from "./productCardMarketingText.module.js";
import i from "../../utils/safehtml.js";
const A = ({
  marketingText: r,
  containerClassName: m,
  unsetPadding: n
}) => {
  const { t } = d();
  return r ? /* @__PURE__ */ o(
    "div",
    {
      className: s([
        e.container,
        n ? e.unsetPadding : "",
        m ?? ""
      ]),
      children: r.length > p ? /* @__PURE__ */ o(
        a,
        {
          numberOfLines: 3,
          openText: t("show_everything"),
          closeText: t("hide"),
          fade: !0,
          children: /* @__PURE__ */ o(i, { data: r })
        }
      ) : /* @__PURE__ */ o(i, { data: r })
    }
  ) : null;
};
export {
  A as ProductCardMarketingText
};
